export default __webpack_public_path__ + "static/media/administracion.6682acb8.png";